import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';

import {clearActiveLabel, clearSearchResults, deselectPetLabel} from '../actions';

class BackButton extends React.Component {
  handleClick = () => {
    this.props.actions.clearSearchResults();
    this.props.actions.deselectPetLabel();
    this.props.actions.clearActiveLabel();
    this.props.actions.push(this.props.url);
  }

  render() {
    return (
      <button type="button" className="btn btn-primary-back" onClick={this.handleClick}>{I18n.t('BACK_TO_LABELS_SEARCH_RESULTS')}
        {/* <span className="lnr lnr-cross float-right" aria-hidden="true"/> */}
      </button>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({clearActiveLabel, clearSearchResults, deselectPetLabel, push}, dispatch)
  };
}

BackButton.propTypes = {
  actions: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired
};

export default connect(null, mapDispatchToProps)(BackButton);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/BackButton.js
 **/